import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'

import './slider.scss'
import LazyLoad from "react-lazy-load"
import cn from "classnames"
import Arrow from "../../icons/ArrowRight"
import Dott from "../../icons/Dott"
import {pushSliderLink} from "../../../helpers/gtm"
import CarouselDecor_Left from "../../icons/CarouselDecor_Left"
import CarouselDecor_Right from "../../icons/CarouselDecor_Right"


function NextArrow(props) {
  const {
    style,
    onClick,
    className,
  } = props
  return (
    <a href={'javascript:void(0)'}
       role="button"
      className={cn('slider-svg-arrow', className)}
      style={{...style}}
      onClick={onClick}
    >
      <Arrow/>
    </a>
  )
}

function PrevArrow(props) {
  const {
    style,
    onClick,
    className,
  } = props
  return (
    <a href={'javascript:void(0)'}
      role="button"
      className={cn('slider-svg-arrow', className)}
      style={{...style}}
      onClick={onClick}
    >
      <Arrow/>
    </a>
  )
}

export default class CarouselSlider extends React.PureComponent {
  constructor(props) {
    super(props)
    this.sliderRef = React.createRef()
    this.transformCount = 0
    this.state = {
      maxDots: 5,
    }
  }

  static propTypes = {
    slides: PropTypes.arrayOf(PropTypes.any).isRequired,
  }

  componentDidMount() {
    const {
      maxDots
    } = this.state

    if (this.sliderRef.current) {

      const slickSlider = this.sliderRef.current.innerSlider;
      const dots = slickSlider.list.offsetParent.querySelectorAll('li');
      const dotsUl = slickSlider.list.offsetParent.querySelector('ul');

      if (dotsUl && dots.length > maxDots) {
        dotsUl.style.transform = 'translateX(0)';
        this.setBoundaries(slickSlider, 'default');
      } else if (dotsUl){
        dotsUl.classList.add('uptomax')
      }
    }
  }

  setBoundaries = (slick, state) => {
    const {
      maxDots
    } = this.state

    if (state === 'default') {
      const dots = slick.list.offsetParent.querySelectorAll('ul li');
      dots[maxDots - 1].classList.add('n-small');
    }
  };

  beforeChangeHandler = (currentSlide, nextSlide) => {
    const {
      maxDots
    } = this.state

    if (this.sliderRef.current) {
      const slickSlider = this.sliderRef.current.innerSlider;
      const dots = slickSlider.list.offsetParent.querySelectorAll('ul li');
      const dotsUl = slickSlider.list.offsetParent.querySelector('ul');
      const totalCount = dots.length;

      if (totalCount > maxDots) {
        if (nextSlide > currentSlide) {
          if (dots[nextSlide].classList.contains('n-small')) {
            if (!dots[dots.length - 1].classList.contains('n-small')) {
              this.transformCount += -46;
              dots[nextSlide].classList.remove('n-small');
              dots[nextSlide + 1].classList.add('n-small');
              dotsUl.style.transform = 'translateX(' + this.transformCount + 'px)';
              const pPointer = nextSlide - 3;
              dots[pPointer - 1].classList.remove('p-small');
              dots[pPointer].classList.add('p-small');
            }
          }
        } else {
          if (dots[nextSlide].classList.contains('p-small')) {
            if (!dots[0].classList.contains('p-small')) {
              this.transformCount += 46;
              dots[nextSlide].classList.remove('p-small');
              dots[nextSlide - 1].classList.add('p-small');
              dotsUl.style.transform = 'translateX(' + this.transformCount + 'px)';
              const nPointer = currentSlide + 1 === totalCount ? currentSlide : currentSlide + 3;
              dots[nPointer].classList.remove('n-small');
              dots[nPointer - 1].classList.add('n-small');
            }
          }
        }
      }
    }
  }

  handleLinkOnClick = (eventLabel, eventLabels) => {
    pushSliderLink(eventLabel, eventLabels)
  }

  render() {
    const {
      slides,
      eventLabels,
    } = this.props

    const sliderSettings = {
      lazyLoad: 'ondemand',
      fade: true,
      arrows: true,
      dots: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      touchThreshold: 15,
      accessibility: true,
      className: 'with-dots',
      prevArrow: <PrevArrow/>,
      nextArrow: <NextArrow/>,
      customPaging: (i) => {
        return (
          <div role={'button'} data-index={i}> <Dott/> </div>
        )
      },
      appendDots: dots => <div className={"slick-dots"}>
        <div className="slick-dots-container">
          <ul>{dots}</ul>
        </div>
      </div>,
      beforeChange: this.beforeChangeHandler,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            lazyLoad: null,
            variableWidth: true,
            arrows: false,
            fade: false,
            centerPadding: '14px',
          },
        },
      ],
    }

    return (

      <div className="carousel-body">

        <div className="carousel-body__decor _left"><CarouselDecor_Left/></div>
        <div className="carousel-body__decor _right"><CarouselDecor_Right/></div>

        <Slider {...sliderSettings} ref={this.sliderRef}>
          {slides.map((slide, key) => (
            <React.Fragment>
              <div className="carousel-slide">
                <picture>
                  {slide.mobile && slide.mobile.length > 0 ? slide.mobile.map(item => (
                    <source
                      key={item.src}
                      srcSet={item.src}
                      media={item.media}
                    />
                  )) : null}
                  <LazyLoad elementType="span">
                    <img className={cn('carousel-slide__image', slide.active && 'active')} src={slide.image}
                         alt={slide.alt} title={slide.title}/>
                  </LazyLoad>
                </picture>
              </div>


              <div
                className={
                  cn('slide-panel')
                }
              >
                <div className="slide-panel-head">
                  <h3 className="slide-panel-head__title">
                    {slide.panel.link ? (
                      <a href={slide.panel.link}>
                        {slide.panel.title}
                      </a>) : (
                      <span>
                    {slide.panel.title}
                    </span>)}
                  </h3>
                </div>
                <div className="slide-panel-description" dangerouslySetInnerHTML={{__html: slide.panel.description}}/>
                {slide.panel.hasOwnProperty('button') && (
                  <div className={cn('slide-panel-link')}>
                    {(slide.panel.button.text && slide.panel.button.link)
                      && (
                        <a
                          href={slide.panel.button.link}
                          target={slide.panel.button.target}
                          onClick={() => {
                            this.handleLinkOnClick(slide.eventLabel, eventLabels)
                          }}
                        >
                          {slide.panel.button.text}
                        </a>)
                    }
                  </div>
                )
                }
              </div>
            </React.Fragment>
          ))}
        </Slider>
      </div>
    )
  }
}
